import { render } from "./LecturePresencesTable.vue?vue&type=template&id=eca035e6&scoped=true"
import script from "./LecturePresencesTable.vue?vue&type=script&lang=js"
export * from "./LecturePresencesTable.vue?vue&type=script&lang=js"

import "./LecturePresencesTable.vue?vue&type=style&index=0&id=eca035e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca035e6"]])

export default __exports__